/**
 * PlanPrep - Represents plan preparation and labeling information.
 * Used to store labels and notes for plan preparation and documentation.
 */
export class PlanPrep {
  /** Label for plan preparation */
  LabelPlanP: string;

  /** Label for notes */
  LabelNote: string;

  /** First label field */
  Label1: string;

  /** Second label field */
  Label2: string;

  /**
   * Creates a new PlanPrep instance
   * @param data - Object containing plan preparation properties
   */
  constructor(data: {
    LabelPlanP: string;
    LabelNote: string;
    Label1: string;
    Label2: string;
  }) {
    this.LabelPlanP = data.LabelPlanP;
    this.LabelNote = data.LabelNote;
    this.Label1 = data.Label1;
    this.Label2 = data.Label2;
  }

  /**
   * Creates a PlanPrep from a plain object (useful for deserialization)
   * @param obj - Plain object with plan preparation data
   * @returns New PlanPrep instance
   */
  static fromObject(obj: Partial<PlanPrep>): PlanPrep {
    return new PlanPrep({
      LabelPlanP: obj.LabelPlanP ?? "",
      LabelNote: obj.LabelNote ?? "",
      Label1: obj.Label1 ?? "",
      Label2: obj.Label2 ?? "",
    });
  }

  /**
   * Converts the PlanPrep to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      LabelPlanP: this.LabelPlanP,
      LabelNote: this.LabelNote,
      Label1: this.Label1,
      Label2: this.Label2,
    };
  }
}


